import React, { useState } from "react";
import FolderTabLayout from "./ui/folder-tab-layout";
import { PhoneOutgoing, BarChart3, Route } from "lucide-react";
import IvrCallLogTab from "./ivr/IvrCallLogTab";
import IvrCallReportingTab from "./ivr/IvrCallReportingTab";
import IvrSynopsisTab from "./ivr/IvrSynopsisTab";

const IvrCallsHub: React.FC = () => {
  const [tab, setTab] = useState("calllog");

  return (
    <FolderTabLayout
      tabs={[
        { value: "calllog", label: "Call Log", icon: PhoneOutgoing },
        { value: "reporting", label: "Reporting", icon: BarChart3 },
        { value: "synopsis", label: "Synopsis", icon: Route },
      ]}
      value={tab}
      onValueChange={setTab}
    >
      {tab === "calllog" && <IvrCallLogTab />}
      {tab === "reporting" && <IvrCallReportingTab />}
      {tab === "synopsis" && <IvrSynopsisTab />}
    </FolderTabLayout>
  );
};

export default IvrCallsHub;
